import {
  SHIPMENTCARRIER_LOADING,
  GET_SHIPMENTCARRIER,
  GET_SHIPMENTCARRIER_SUCCESS,
  GET_SHIPMENTCARRIER_FAIL,
  ADD_SHIPMENTCARRIER_SUCCESS,
  ADD_SHIPMENTCARRIER_FAIL,
  DELETE_SHIPMENTCARRIER_SUCCESS,
  DELETE_SHIPMENTCARRIER_FAIL,
  UPDATE_SHIPMENTCARRIER_SUCCESS,
  UPDATE_SHIPMENTCARRIER_FAIL,
  SHIPMENTCARRIER_RESET
} from "./actionType";

const INIT_STATE = {
  shipmentCarriers: [],
  error: {},
};

const ShipmentCarrier = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SHIPMENTCARRIER_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SHIPMENTCARRIER:
          return {
            ...state,
            shipmentCarriers: action.payload.data,
            isShipmentCarrierCreated: false,
            isShipmentCarrierSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SHIPMENTCARRIER_FAIL:
      switch (action.payload.actionType) {
        case GET_SHIPMENTCARRIER_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isShipmentCarrierCreated: false,
            isShipmentCarrierSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SHIPMENTCARRIER: {
      return {
        ...state,
        isShipmentCarrierCreated: false,
        loading: true,
      };
    }

    case SHIPMENTCARRIER_LOADING: {
      return {
        ...state,
        isShipmentCarrierCreated: false,
        loading: true,
      };
    }

    case ADD_SHIPMENTCARRIER_SUCCESS:
      return {
        ...state,
        isShipmentCarrierCreated: true,
        loading: false,
        shipmentCarriers: [action.payload.data, ...state.shipmentCarriers],
      };

    case ADD_SHIPMENTCARRIER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SHIPMENTCARRIER_SUCCESS:
      return {
        ...state,
        loading: false,
        isShipmentCarrierCreated: true,
        shipmentCarriers: state.shipmentCarriers.filter(
          shipmentCarrier => shipmentCarrier.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SHIPMENTCARRIER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SHIPMENTCARRIER_SUCCESS:
      return {
        ...state,
        loading: false,
        isShipmentCarrierCreated: true,
        shipmentCarriers: state.shipmentCarriers.map(shipmentCarrier =>
          shipmentCarrier.id.toString() === action.payload.data.id.toString() ? { ...shipmentCarrier, ...action.payload.data } : shipmentCarrier
        ),
      };

    case UPDATE_SHIPMENTCARRIER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SHIPMENTCARRIER_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ShipmentCarrier;